import { useState } from 'react';
import useAPI from './api';
import { openSignInWindow } from '../components/Modals/ConnectPopup';

export default function useReconnectIdentity() {
  const API = useAPI();
  const [reconnecting, setReconnecting] = useState(false);

  const reconnect = async (provider) => {
    const url = `${process.env.REACT_APP_AUTH_HOST}/auth/${provider}`;
    setReconnecting(true);
    try {
      const data = await openSignInWindow(url, 'connect');
      const [ok] = await API.connectContactList({ provider, oauth_data: data });
      return ok;
    } catch {
      // user closed the popup or OAuth failed
      return false;
    } finally {
      setReconnecting(false);
    }
  };

  return { reconnect, reconnecting };
}
